import { USER_PERMISSIONS } from '../types'

export const userPermissions = permissions => {
  return dispatch => {
    dispatch({
      type: USER_PERMISSIONS,
      payload: permissions,
    })
  }
}
